<template>
  <div class="flex gap-4 flex-col justify-center items-center pa-4 rounded-2 overflow-hidden bg-primary6">
    <CIcon :color="themeVars.primary4" fa-type="fa-kit" :icon="ComponentIcon.CollectionPlayer" size="36" />

    <CButton
      :style="{
        '--n-color': 'transparent',
        '--n-color-pressed': themeVars.primary5,
        '--n-color-focus': themeVars.primary5,
        '--n-color-hover': themeVars.primary5,
        '--n-border': `1px solid ${themeVars.primary}`,
      }"
      type="default"
      @click="emit('selectCollectionContent')"
    >
      {{ t('canvasUI.collectionPlayer.create') }}
    </CButton>
  </div>
</template>

<script lang="ts" setup>
import useThemeVars from '@lib/composables/useThemeVars'
import type { CollectionPlayer } from '@collection-player/types/collection-player.type'
import { ComponentIcon } from '@canvas-builder/types/canvas'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import CButton from '@lib/components/CButton/CButton.vue'
import { useI18n } from 'vue-i18n'

defineProps<{
  data?: CollectionPlayer
}>()

const emit = defineEmits<{
  selectCollectionContent: []
}>()

const { t } = useI18n()
const themeVars = useThemeVars()
</script>
